import { Box, Button, Drawer, FormControl, InputLabel, MenuItem, Select, Stack, Tooltip, Typography } from '@mui/material'
import React, { Component } from 'react'
import './StoreReports.css';
import { Colors } from '../../../Styles/Colors';
import { ImagePaths } from '../../../Utility/ImagePaths';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonCorporateAndInsuranceDetails, CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import { ContentInTooltip, formatDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../../Pharmacy/PharmacyReports/PharmaFilter';
import { DateTime } from 'luxon';
import dayjs from "dayjs";
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';

const Active_Inactive_Status = [
    { value: 'All', label: 'All' },
    { value: true, label: 'Active' },
    { value: false, label: 'Inactive' }
]
class StoreStockCorrectionLog extends Component {

  constructor(props) {
    super(props)
    this.state = {
      stockCorrectionData: [],
      page: 0,
      pageSize: 10,
      rowCount: 0,
      filterDatas: {
        'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
        "dateIndex": 1,
        'isActive': 'All'
      },
      pageName: 'stockCorrectionLog',
      filterOpen: false
    }
  }

  componentDidMount() {
    this.getStockCorrectionLogData()
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  renderFilter = (data) => {
    this.setState({
      filterDatas: data,
      filterOpen: false,
    }, () => { this.getStockCorrectionLogData() })
  }

  ClosePopUp() {
    this.setState({
      filterOpen: false,
    })
  }

  clearFilter = (data) => {
    this.setState({
      filterDatas: data
    })
  }

  gridToolBar = () => {
    var { t } = this.props
    let TextArray = [
      { label: "From Date", value: formatDate(this.state.filterDatas.fromDate) },
      { label: "To Date", value: formatDate(this.state.filterDatas.toDate) },
    ]
    return (
      <Box>
        <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
      </Box>

    )
  }

  getStockCorrectionLogData = () => {
    try {
      this.LoaderFunction(true)
      let active_status = this.state.filterDatas.isActive === 'All' ? '' : this.state.filterDatas.isActive
      RestAPIService.getAll(Serviceurls.STORE_INVENTORY_STOCK_CORRECTION_REPORT_GET + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&is_active=${active_status}`)
        .then((response) => {
          if (response.data.status === 'Success') {
            this.setState({
              stockCorrectionData: response.data.data
            }, ()=>{ this.LoaderFunction(false) })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMessage(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getStockCorrectionLogExcel = () => {
    try {
      let active_status = this.state.filterDatas.isActive === 'All' ? '' : this.state.filterDatas.isActive
      this.setState({disableBtn: true})
      RestAPIService.excelGet(Serviceurls.STORE_INVENTORY_STOCK_CORRECTION_REPORT_GET + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&is_active=${active_status}&export_type=excel`).
        then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data; //here we load our csv data 

            let filename = response.headers["content-disposition"]?.split("filename=")[1]
            // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});

            var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();
            this.setState({disableBtn: false})
          }
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMessage(error.response?.data?.message);
          } else {
            this.errorMessage(error.message);
          }
          this.setState({disableBtn: false})
        })
    } catch (error) {
      this.errorMessage(error.message);
      this.setState({disableBtn: false})
    }
  }

  StockCorrectionLogPrint = () => {
    try {
      this.setState({disabled: true})
      let active_status = this.state.filterDatas.isActive === 'All' ? '' : this.state.filterDatas.isActive
      RestAPIService.getAll(Serviceurls.STORE_INVENTORY_STOCK_CORRECTION_REPORT_GET + `?from_date=${this.state.filterDatas.fromDate}&to_date=${this.state.filterDatas.toDate}&is_active=${active_status}&export_type=pdf`).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({disabled: false})
        }).catch((error) => {
          if(error?.response?.data?.message){
            this.errorMessage(error?.response?.data?.message)
          }else{
            this.errorMessage(error.message)
          }
          this.setState({disabled: false})
        })
    } catch (error) {
      this.errorMessage(error.message)
      this.setState({disabled: false})
    }
  }
  FilterDate = (from, to, index) => {
    this.state.filterDatas.fromDate = from
    this.state.filterDatas.toDate = to
    this.state.filterDatas.dateIndex = index
    this.setState({ filterDatas: this.state.filterDatas })
  }

  renderFilterScreen = () => {
    return (
      <Box className='eMed_rts_filter_container' >
        <Box className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>Filter</Typography>
          <Tooltip>
            <Button onClick={() => { this.setState({ filterOpen: false }) }}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
            </Button>
          </Tooltip>
        </Box>
        <Box className='eMed_rts_middle'>
          <Box className='eMed_date_filter'>
            <CommonDatePicker
              FromDate={this.state.filterDatas.fromDate}
              ToDate={this.state.filterDatas.toDate}
              DateIndex={this.state.filterDatas.dateIndex}
              SelectedDates={this.FilterDate.bind(this)}
              HideAllMenu={true} />
          </Box>
          <Box className='eMed_rts_dropdown'>
            <FormControl size='small' sx={{ width: '20vw', margin: '0.5vw' }}>
              <InputLabel>Select Status</InputLabel>
              <Select
                label='Select Status'
                value={this.state.filterDatas.isActive}
                onChange={(e) => {
                  let value = e.target.value
                  this.state.filterDatas['isActive'] = value
                  this.setState({
                    filterDatas: this.state.filterDatas
                  })
                }}
              >
                {Active_Inactive_Status.map((item) => (
                  <MenuItem emed_tid={item.label} value={item.value} key={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box>
          <Stack spacing={2} direction="row" justifyContent={'center'}>
            <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => { 
              this.setState({
                filterDatas: {
                  'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                  "dateIndex": 1,
                  'isActive': 'All'
                },
              },()=>{
                this.getStockCorrectionLogData()
              })
             }}>Clear</Button>
            <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
              this.setState({
                filterOpen: false
              },()=>{
                this.getStockCorrectionLogData()
              })
            }}>Search</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  render() {
    const { t } = this.props
    this.state.stockCorrectionData.forEach((element, index) => element.sno = index + 1)
    const columns = [
      {
        field: 'brand_name', headerName: "Product Name", flex: 0.09,
        renderCell: (params) => (<Box component={'div'}>
          {ContentInTooltip(params?.row?.brand_name, 12, '0.9vw', 600)}
          {ContentInTooltip(params?.row?.product_code, 12, '0.8vw')}
        </Box>), valueGetter: ({ row }) => {
          const Name = row?.brand_name || "";
          const Generic = row?.generic_name || "";
          const Dosagetype = row?.dosage_type || "";
          const ProductCode = row?.product_code || "";
          return `${Name} ${Generic} ${Dosagetype} ${ProductCode}`;
        }
      },
      {
        field: 'batch_no', headerName: "Batch No.", flex: 0.09, headerAlign: "center", align: "center",
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.batch_no?.length > 12 ? <Tooltip placement='top' title={params?.row?.batch_no} arrow><div>{params?.row?.batch_no?.slice(0, 12) + '...'}</div></Tooltip> :
            params?.row?.batch_no ? params?.row?.batch_no : '-'}
        </Box>)
      },
      {
        field: 'expiry_date', headerName: "Expiry Date", flex: 0.09, headerAlign: 'center', align: 'center',
        renderCell: (params) => (<Box component={'div'}>
          {params?.row?.expiry_date?.length > 12 ? <Tooltip placement='top' title={params?.row?.expiry_date} arrow><div>{params?.row?.expiry_date?.slice(0, 12) + '...'}</div></Tooltip> :
            params?.row?.expiry_date ? params?.row?.expiry_date : '-'}
        </Box>)
      },
      {
        field: 'modified_by', headerName: `Updated By`, flex: 0.09,
        renderCell: (params) => (<Box component={'div'}>{params.row?.modified_by ? params.row?.modified_by : '-'}</Box>)
      },
      {
        field: 'previous_quantity', headerName: `Previous Qty`, flex: 0.09, type: "number",
        renderCell: (params) => (<Box component={'div'}>{params.row?.previous_quantity ? params.row?.previous_quantity : '0'}</Box>)
      },
      {
        field: 'adjusted_quantity', headerName: `Adjusted Qty`, flex: 0.09, type: "number",
        renderCell: (params) => (<Box component={'div'}>{params.row?.adjusted_quantity ? params.row?.adjusted_quantity : '0'}</Box>)
      },
      {
        field: 'available_quantity', headerName: `Avaliable Qty`, flex: 0.08, type: "number",
        renderCell: (params) => (<Box component={'div'}>{params.row?.available_quantity ? params.row?.available_quantity : '0'}</Box>)
      },
      {
        field: 'comments', headerName: "Reason", flex: 0.08,
        renderCell: ({ row }) => (<Box component={'div'}>
          {row?.comments?.length > 12 ?
            <Tooltip placement='top' title={row?.comments} arrow>
              <div>{row?.comments?.slice(0, 12) + '...'}</div>
            </Tooltip> :
            row?.comments || '-'}
        </Box>)
      },
      {
        field: 'modified_date', headerName: `Correction Date & Time`, flex: 0.12, type: "string",
        valueGetter: ({ row }) => {
          const dateStr = row?.modified_date;
          return dateStr || "";
        },
        sortComparator: (v1, v2) => {
          const d1 = v1 ? dayjs(v1, "DD-MM-YYYY hh:mm A").valueOf() : 0;
          const d2 = v2 ? dayjs(v2, "DD-MM-YYYY hh:mm A").valueOf() : 0;
          return d1 - d2;
        },
        renderCell: (params) => (<Box component={'div'}>{params.row?.modified_date || '-'}</Box>)
      },
    ]
    return (
      <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
        <Box component={'div'} className='eMed_Pharma_rts_header' sx={{ height : "7vh"}}>
          <Box component={'div'} flex={0.8} display={'flex'}>

          </Box>
          <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
            <Button emed_tid = "rpt_stkCrt_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
              <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} />
            </Button>
            <Button className='eMed_Pharma_rts_btn' disabled={this.state.disabled}>
              <Box component={'img'} src={ImagePaths.LabPrintIcon.default} alt='print' height={'2.3vw'} width={'2.3vw'} onClick={() => this.StockCorrectionLogPrint()}/>
            </Button>
            <Button  emed_tid = "rpt_stkCrt_export" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => this.getStockCorrectionLogExcel()}>
              <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} />
            </Button>
          </Box>
        </Box>
        <Box component={'div'} className='eMed_Pharma_rts_tbl_card' sx={{ height : "72vh"}}>
          <DataGrid
            className='eMed_Pharma_table'
            rows={this.state.stockCorrectionData}
            columns={columns}
            page={this.state.page}
            pageSize={this.state.pageSize}
            getRowId={(row) => row['sno']}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            components={{
              Toolbar: this.gridToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }}
            rowCount={this.state.stockCorrectionData?.length}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
            rowsPerPageOptions={[10, 20, 30]}
            headerHeight={40}
            disableSelectionOnClick
            pagination
            loading={this.state.isLoader}
          />
        </Box>

        <Drawer
          anchor={'right'}
          open={this.state.filterOpen}
          ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
        >
          {this.renderFilterScreen()}
        </Drawer>

        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
      </Box>
    )
  }
}

export default withTranslation()(StoreStockCorrectionLog)